
import { Component } from '@angular/core';
import { TopHeaderFiltersComponent } from './top-header-filters/top-header-filters.component';

@Component({
  selector: 'st-top-header-right-section',
  standalone: true,
  imports: [TopHeaderFiltersComponent],
  templateUrl: './top-header-right-section.component.html',
})
export class TopHeaderRightSectionComponent {
  constructor() {}
}
